import { createAction } from 'typesafe-actions';

export const logout = createAction('auth/LOGOUT')();
